import { getCurrentEnvironment, EnvironmentType } from '../../diagnostics/EnvironmentType'

let DEV_AUTH = {
  // REQUIRED - Amazon Cognito Identity Pool ID
  identityPoolId: 'us-west-2:53cf8a59-3ca6-4abc-88bf-04d97428d389',
  region: 'us-west-2',
  userPoolId: 'us-west-2_VeOXZlccL',
  userPoolWebClientId: '5dulh3k93fvnva69lralp7dofo'
}
let STAGE_AUTH = {
  // REQUIRED - Amazon Cognito Identity Pool ID
  identityPoolId: 'us-west-2:1f52f233-a2df-4658-9d09-6d1f41d47ef8',
  region: 'us-west-2',
  userPoolId: 'us-west-2_dtK4p6smf',
  userPoolWebClientId: '214mhth3g0hqfe1lekdbdcf76u'
}

let PROD_AUTH = {
  // REQUIRED - Amazon Cognito Identity Pool ID
  identityPoolId: 'us-west-2:6cdb487b-db1c-46a6-bcfa-ac3af446647c',
  region: 'us-west-2',
  userPoolId: 'us-west-2_aLRaCLaUe',
  userPoolWebClientId: '1ur06i2emu3i86rkj26mdfeqjf'
}

let env = getCurrentEnvironment()

let auth = env === EnvironmentType.DEV ? DEV_AUTH : env === EnvironmentType.STAGE ? STAGE_AUTH : PROD_AUTH

export const AWS_CONFIG = {
  Auth: auth
}



// WEBPACK FOOTER //
// ./src/config/aws/awsConfig.ts